import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { Snackbar } from '@material-ui/core';
import { ALERT_OPEN_DURATION } from 'constants/style';
import { AlertType } from 'models';

interface Props {
  isOpen: boolean;
  type: AlertType;
  message: string;
  onClose: () => void;
}

const Notification: React.FC<Props> = (props) => {
  const { isOpen, message, type, onClose } = props;

  const handleClose = (): void => {
    onClose();
  };

  return (
    <Snackbar
      open={isOpen}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={ALERT_OPEN_DURATION}
      onClose={handleClose}
    >
      <MuiAlert
        variant='standard'
        elevation={6}
        onClose={handleClose}
        severity={type}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default Notification;
